<template>
    <div>
        <modal name="confirm-new-form">
            <div class="bg-orange-200 text-orange-800 p-4 rounded mb-4"><i class="fas fa-exclamation-triangle mr-1"></i>{{ $tt('En créant une nouvelle demande, vous allez perdre votre ancienne saisie') }}</div>
            <div class="text-lg font-bold">{{ $tt('Souhaitez-vous créer une nouvelle demande ?') }}</div>
            <div class="flex items-center gap-2 mt-2">
                <button @click="makeNewClaim" class="bg-green-500 hover:bg-green-600 duration-200 rounded-lg px-4 py-2 text-white font-bold"><i class="fas fa-check mr-0.5"></i> {{ $tt('Oui') }}</button>
                <button @click="$modal.hide('confirm-new-form')" class="bg-red-500 hover:bg-red-600 duration-200 rounded-lg px-4 py-2 text-white font-bold"><i class="fas fa-times mr-0.5"></i> {{ $tt('Non') }}</button>
                
            </div>
        </modal>
        <sav-template
        :back-button="false"
        >
            <div v-if="$route.query.app_not_found && $companyTool.confFile().not_found_msg" class="p-8 mb-4 rounded-xl bg-green-100 text-green-800">
                <div class="font-bold text-xl"><i class="fas fa-check mr-1"></i> Demande envoyée</div>
                <p class="text-lg font-light mt-0.5" v-html="$companyTool.confFile().not_found_msg"></p>
            </div>
            <!-- <continue-card v-if="formWaiting" class="mb-4"></continue-card> -->

            <div id="new-form-container" class="p-6 mb-4 bg-white shadow my-rounded">
                <div class="items-center md:flex">
                    <img class="hidden w-full md:w-32 lg:block" src="https://disticloudfiles.net/img/savinfo/default/demande_de_sav.webp" alt="">
                    <div class="ml-3 grow">
                        <template v-if="!formWaiting">
                            <h3 class="text-3xl font-semibold">{{$t('accueil.demande_de_sav')}}</h3>
                            <div class="my-2 text-base font-light text-gray-500">{{$t('accueil.un_souci_avec_un_produit_il_vous_suffit_de_commencer_une_nouvelle_demande_de_sav')}}</div>
                        </template>
                        <div class="bg-slate-200 border-slate-300 text-slate-800 p-4 rounded-lg mb-4 mt-2" v-if="formWaiting">
                            <div class="text-lg font-bold"><i class="fas fa-exclamation-triangle mr-1"></i> {{$tt('Vous avez un formulaire non terminé')}}</div>
                            <p class="my-1 font-light">{{$tt('Souhaitez-vous reprendre votre demande ?')}}</p>
                            <div class="md:flex items-center gap-2 mt-2">
                                <button @click="$router.push({name: 'form.home'})" class="bg-green-500 hover:bg-green-600 duration-200 rounded-lg px-4 py-2 text-white font-bold text-sm mb-2 md:mb-0">{{ $tt('Continuer') }}</button>
                                <button @click="$modal.show('confirm-new-form')" class="bg-slate-500 hover:bg-slate-600 duration-200 rounded-lg px-4 py-2 text-white font-bold text-sm" v-if="formWaiting">
                                    {{ $tt('Faire une nouvelle demande') }}
                                </button>
                            </div>
                        </div>
                        <template v-if="!formWaiting">
                            <router-link :to="{ name: 'form.home'}" test-id="go-to-form" class="cursor-pointer default-text-selected hover-default-text-selected">
                                {{$t('accueil.commencer')}} <i class="fas fa-arrow-alt-circle-right ml-0.5"></i>
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>
            <div class="p-6 my-4 bg-white shadow my-rounded">
                <div class="items-center md:flex">
                    <img class="hidden w-full md:w-32 lg:block" src="https://disticloudfiles.net/img/savinfo/default/mes_produits.webp" alt="">
                    <div class="ml-3">
                        <h3 class="text-3xl font-semibold">{{$t('accueil.mes_produits')}}</h3>
                        <div class="my-2 text-base font-light text-gray-500">{{$t('accueil.retrouver_tous_vos_produits')}}</div>
                        <router-link :to="{ name: 'user.product.list'}" test-id="go-to-products" class="cursor-pointer default-text-selected hover-default-text-selected">
                            {{$t('accueil.consulter')}} <i class="fas fa-arrow-alt-circle-right ml-0.5"></i>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="p-6 my-4 bg-white shadow my-rounded">
                <div class="items-center md:flex">
                    <img class="hidden w-full md:w-32 lg:block" src="https://disticloudfiles.net/img/savinfo/default/mon_compte.webp" alt="">
                    <div class="ml-3">
                        <h3 class="text-3xl font-semibold">{{$t('accueil.mon_compte')}}</h3>
                        <div class="my-2 text-base font-light text-gray-500">{{$t('accueil.retrouver_toutes_les_informations_de_votre_compte')}}</div>
                        <router-link :to="{ name: 'user.update'}" test-id="go-to-account" class="cursor-pointer default-text-selected hover-default-text-selected">
                            {{$t('accueil.voir')}} <i class="fas fa-arrow-alt-circle-right ml-0.5"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </sav-template>
    </div>
</template>

<script>
import ContinueCard from '@/processes/cards/other/ContinueCard.vue'

export default {
    components: { ContinueCard },
    
    computed: {
        formWaiting() {
            if (localStorage.getItem('form-data') && Object.keys(JSON.parse(localStorage.getItem('form-data'))).length > 1) {
                return true
            }
            return false
        }
    },

    methods: {
        makeNewClaim() {
            localStorage.removeItem('form-data')
            this.$router.push({name: 'form.home'})
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/Home.vue